import React from 'react';
import { fetchAuthSession } from '@aws-amplify/auth';


const AddCapsuleImage = async (capsuleID: string, image: string) => {
  const apiUrl = `https://lfnawfdz0a.execute-api.ap-southeast-2.amazonaws.com/capsule/addimage`; 
  const payload = {
    "capsuleID": capsuleID,
    "Image": image
  }

  try {
    const { tokens } = await fetchAuthSession();
    const authToken = tokens?.accessToken?.toString();

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'x-api-key': authToken!, // Assuming token is available in fetchAuthSession
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    if (response.ok) {
      const data = await response.json();
      console.log(response);
    } else {
      console.error('Failed to add image');
    }
  } catch (err) {
    console.error('Failed to add image', err);
  }

  return null; // The component doesn't render anything, just fetches data
};

export default AddCapsuleImage;
